import type { Meta } from '~/Actions/ActionApplications';
import type { InferActionsType } from '~/Reducers';
import type { IApiError } from '~/types/api';
import type { ClanSearchRatingResultItem, ClanSearchResultItem, IBattleType, IClanData } from '~/types/declaration';

export const SEARCH_CHANGE_BATTLE_TYPE = 'SEARCH_CHANGE_BATTLE_TYPE';
export const SEARCH_CHANGE_PAGE = 'SEARCH_CHANGE_PAGE';
export const SEARCH_CLEAR_STATE = 'SEARCH_CLEAR_STATE';
export const SEARCH_START_FETCHING = 'SEARCH_START_FETCHING';
export const SEARCH_UPDATE_RESULT = 'SEARCH_UPDATE_RESULT';
export const SEARCH_UPDATE_ERROR = 'SEARCH_UPDATE_ERROR';
export const SEARCH_CHANGE_TERM = 'SEARCH_CHANGE_TERM';
export const SEARCH_APPEND_TERM_TO_HISTORY = 'SEARCH_APPEND_TERM_TO_HISTORY';

type UpdateSearchType = {
  clans: (ClanSearchResultItem | ClanSearchRatingResultItem)[];
  _meta_: Meta;
};

export type ActionsType = InferActionsType<typeof actionsSearch>;

export const actionsSearch = {
  changeBattleType: (battleType: IBattleType) =>
    ({
      type: SEARCH_CHANGE_BATTLE_TYPE,
      battleType,
    }) as const,

  changePage: (page: number) =>
    ({
      type: SEARCH_CHANGE_PAGE,
      page,
    }) as const,

  clearSearchState: () =>
    ({
      type: SEARCH_CLEAR_STATE,
    }) as const,

  startFetching: () =>
    ({
      type: SEARCH_START_FETCHING,
    }) as const,

  updateSearchResult: (data: UpdateSearchType) =>
    ({
      type: SEARCH_UPDATE_RESULT,
      data,
    }) as const,

  updateError: (error?: IApiError) =>
    ({
      type: SEARCH_UPDATE_ERROR,
      error: error || null,
    }) as const,

  changeTerm: (term: string) =>
    ({
      type: SEARCH_CHANGE_TERM,
      term,
    }) as const,

  appendTermToHistory: (item: IClanData, accountId: number) =>
    ({
      type: SEARCH_APPEND_TERM_TO_HISTORY,
      item,
      accountId,
    }) as const,
};
